export const basicFields = [
  { name: "physical_status", label: "Physical Status", type: "text" },
  { name: "weight", label: "Weight", type: "number" },
   { name: "skin_tones", label: "Skin color", type: "text" },
  { name: "marital_status", label: "Marital Status", type: "text" },
  { name: "drinking_habits", label: "Drinking Habits", type: "text" },
  { name: "eating_habits", label: "Eating Habits", type: "text" },
  { name: "smoking_habits", label: "Smoking Habits", type: "text" },
  { name: "vehicles", label: "Vehicles", type: "text" },  
  { name: "house", label: "House/Property", type: "text" }, 
  { name: "land", label: "Land", type: "text" },           
  { name: "business", label: "Business", type: "text" },
  { name: "college_name", label: "College name", type: "text" },
  { name: "job_company_name", label: "job Company name", type: "text" },
];

export const religionFields = [
  { name: "kuldevi", label: "Kuldevi", type: "text" },
  { name: "kuldevta", label: "Kuldevta", type: "text" },
  { name: "kul", label: "Kul", type: "text" },
  { name: "gothra", label: "Gotra", type: "text" },
  { name: "time_of_birth", label: "Time of Birth", type: "time" },
  { name: "place_of_birth", label: "Place of Birth", type: "text" },
  { name: "manglik", label: "Manglik / Ansik", type: "text" },
];

export const familyFields = [
  { name: "family_values", label: "Family Values", type: "text" },
  { name: "family_type", label: "Family Type", type: "text" },
  { name: "family_status", label: "Family Status", type: "text" },
  { name: "vansh", label: "Vansh", type: "text" },
  { name: "no_of_brothers", label: "No of Brothers", type: "number" },
  { name: "brother_qualification", label: "Brother Qualification", type: "text" },
  { name: "brother_occupation", label: "Brother Occupation", type: "text" },
  { name: "no_of_sisters", label: "No of Sisters", type: "number" },
  { name: "sister_qualification", label: "Sister Qualification", type: "text" },
  { name: "sister_occupation", label: "Sister Occupation", type: "text" },
  { name: "fathers_occupation", label: "Father's Occupation", type: "text" },
  { name: "mothers_occupation", label: "Mother's Occupation", type: "text" },
  { name: "family_location", label: "Belong From", type: "text" },
];
export const Maternal_Family_Details = [
  { name: "mama_name", label: "Mama Name", type: "text" },
  { name: "nana_name", label: "Nanaji name", type: "text" },
  { name: "mama_gotra", label: "Gotra", type: "text" },
  { name: "mama_kuldevi", label: "kuldevi", type: "text" },
  { name: "mama_place", label: "Belong From", type: "text" },
];

